import React from 'react';
import PropTypes from 'prop-types';
import { shortDateFormatWithSlashes } from '../../../../agent-production/helpers/dataFormatters';
import {
    getSelectedAreaInfo,
    truncateLine,
    getFieldValues,
    getTimeFrame
} from '../../../helpers/pdf';
import {
    pdfDisclaimer,
    searchTerms
} from '../../../../constants';
import { MAX_LINE_LENGTH } from '../../../constants/pdf';
import { appLabels, runningApp } from '../../../../constants/app';

const Footer = ({
    loadedSearchCriteria,
    selectedBeginValue,
    selectedEndValue,
    selectedMls,
    searchResults,
    timeFrameTitle,
    listingTypeId,
    isComparisonSetView,
    listingStatus,
    areaTypeTitle,
    module,
    config,
    officeListName
}) => {
    const timeFrame = getTimeFrame(searchResults, timeFrameTitle, selectedBeginValue, selectedEndValue);
    const { selectedAreaType, selectedArea } =  getSelectedAreaInfo(loadedSearchCriteria, module, areaTypeTitle);
    
    const propertyTypes = config.shouldShowPropertyTypes ? getFieldValues(loadedSearchCriteria, 'propertyType') : '';
    const buildDetailItem = (label, value) => <div key={label} className="detail-item"><strong>{label}:</strong> {value}</div>;

    const detailFields = config?.getDetailFields({
        selectedMls,
        timeFrame,
        loadedSearchCriteria,
        listingTypeId,
        isComparisonSetView,
        listingStatus,
    });

    return (
        <div className="footer">
            <div className="footer-divider" />
            <div className="footer-content">
                <div>
                    <div className="report-details">
                        <div className="detail-line">
                            {detailFields.map(({ label, value }) => buildDetailItem(label, value))}
                        </div>
                        {propertyTypes &&
                            <div className="detail-item full-width">
                                <strong>{searchTerms.propertyTypesSA}:</strong> {truncateLine(propertyTypes, MAX_LINE_LENGTH - `${searchTerms.propertyTypesSA}: `.length)}
                            </div>
                        }
                        {config.shouldShowOfficeListFooter && officeListName &&
                            <div className="detail-item full-width office-list-footer">
                                <strong>{searchTerms.officeList}:</strong> {officeListName}
                            </div>
                        }
                        <div className="detail-item full-width"><strong>{selectedAreaType}</strong> {truncateLine(selectedArea, MAX_LINE_LENGTH - (selectedAreaType + ' ').length)}</div>
                    </div>
                </div>
                <div className="disclaimer">
                    {pdfDisclaimer(selectedMls, appLabels[runningApp])}
                </div>
                <div className="date">{shortDateFormatWithSlashes(new Date().toISOString())}</div>
            </div>
        </div>
    );
};

Footer.propTypes = {
    selectedMls: PropTypes.object,
    loadedSearchCriteria: PropTypes.object,
    selectedBeginValue: PropTypes.string,
    selectedEndValue: PropTypes.string,
    searchResults: PropTypes.array,
    timeFrameTitle: PropTypes.object,
    listingTypeId: PropTypes.string,
    isComparisonSetView: PropTypes.bool,
    listingStatus: PropTypes.string,
    module: PropTypes.string,
    areaTypeTitle: PropTypes.string,
};

export default Footer;
